angular.module('editTrillToBeCompiledNewsModule')
    .directive('unicodeEmoji', ['trsHttpService', '$q', function(trsHttpService, $q){
        return {
            restrict: 'E',
            scope: {
                addEmoji: '&',
                emojiStatus: '='
            }, 
            templateUrl: './editingCenter/trill/service/emoji/emojiUnicode_tpl.html',
            replace: true,
            link: function($scope, iElm, iAttrs, controller) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 状态初始化
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {}
                    $scope.data = {
                        items: [],
                    }
                }
                /**
                 * [initData description] 数据初始化
                 * @return {[type]} [description]
                 */
                function initData() {
                    var deferred = $q.defer();
                    trsHttpService.httpServer('./editingCenter/trill/service/emoji/emoji.json', '', 'get').then(function(data) {
                        $scope.data.items = data;
                        deferred.resolve();
                    });
                    return deferred.promise;
                }
                /**
                 * [closeEmoji description] 关闭选择表情弹窗
                 * @return {[type]} [description]
                 */
                $scope.closeEmoji = function() {
                    $scope.emojiStatus = false;
                };


            }
        }
    }]);